import PhotoGrayIcon from '@assets/images/common/image_dummy.svg';
import { MediaTag } from '@src/api/types/mediaTag';
import Tag from '@src/ui/elements/Company/Tag';
import { stripHtmlTags } from '@src/utils/stringUtils';
import React from 'react';
import { Link } from 'react-router-dom';

interface ArticlePreviewItemProps {
  title: string;
  content: string;
  hideMobileDescription?: boolean;
  date: string;
  category: { id: number; name: string; slug: string };
  tags: MediaTag[];
  thumbnail: string;
}

const ArticlePreviewItem: React.FC<ArticlePreviewItemProps> = ({
  title,
  content,
  hideMobileDescription,
  date,
  category,
  tags,
  thumbnail,
}) => {
  return (
    <article>
      <div className='flex flex-col gap-3 transition-opacity hover:opacity-80 md:flex-row'>
        <Link
          to={''}
          className='block md:w-[44%]'
        >
          <img
            className='aspect-[360/202] size-full object-contain'
            src={thumbnail}
            alt={title}
            width={360}
            height={202}
            loading='lazy'
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = PhotoGrayIcon;
            }}
          />
        </Link>
        <div className='flex flex-col justify-between md:ml-1 md:w-[52%]'>
          <div>
            <div className='mb-2 flex items-center justify-between'>
              <Link
                to={''}
                className='max-w-[70%] cursor-pointer truncate border-b-2 border-primary-500 py-1 text-xs text-primary'
              >
                {category.name}
              </Link>
              <div className='flex items-center gap-2'>
                <time
                  className='text-[10px] text-gray-400'
                  dateTime={date}
                >
                  {date}
                </time>
              </div>
            </div>
            <Link
              to={''}
              className='block md:mt-3'
              data-testid='article-title-link'
            >
              <h2 className='truncate text-xl font-semibold md:line-clamp-2 md:whitespace-normal md:text-sm'>
                <span className='block truncate md:overflow-visible md:whitespace-normal'>
                  {title}
                </span>
              </h2>
            </Link>
          </div>
        </div>
      </div>
      <div className='pt-2'>
        <p className={`line-clamp-2 text-sm leading-7 ${hideMobileDescription && 'md:hidden'}`}>
          {stripHtmlTags(content)}
        </p>
        <ul className='flex flex-wrap gap-2 pt-1'>
          {tags.map((tag) => (
            <Tag
              key={tag.id}
              label={tag.name}
              to={''}
            />
          ))}
        </ul>
      </div>
    </article>
  );
};

export default ArticlePreviewItem;
